import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { AccountBasicData } from 'src/app/models/account/account-basic-data.model';
import { Despacho } from 'src/app/models/virtual-store/despacho.model';
import { Ubigeo } from 'src/app/models/ubigeo.model';
import { CommonService } from 'src/app/services/common.service';
import { OrderService } from 'src/app/services/order.service';
@Component({
  selector: 'app-financing-delivery',
  templateUrl: './financing-delivery.component.html'

})
export class FinancingDeliveryComponent implements OnInit {

  @Input() fullName: string;
  @Output() stepCompleted = new EventEmitter();
  formGroup: FormGroup; 
  fechaMinRecojo: Date;
  fechaMaxRecojo: Date = new Date();
  UbigeoList: Ubigeo[];
  provincias: Ubigeo[];
  distritos: Ubigeo[];
  departamentos: Ubigeo[];
  dataUbigeo: Ubigeo[];
  departamentoId: number;
  provinciaId: number;
  distritoId: number;
  clientBasicData: AccountBasicData = new AccountBasicData();
  unsubscribe$ = new Subject();
  despacho = new Despacho(); 
  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private authService: AuthService,
    private _orderService: OrderService
  ) {
    this.clientBasicData = this.authService.getBasicData();
    
  }
  ngOnInit() {
    this.loadUbigeo();
    this.createForm();         
  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      departamentoId: ['' , [Validators.required]],
      provinciaId: ['', [Validators.required]],
      distritoId: ['', [Validators.required]],
      calleDespacho: ['', [Validators.required]],
      referenciaDespacho: ['', [Validators.required]],
      fechaEnvio: ['', [Validators.required]],
      horarioEnvio: ['', [Validators.required]],
      clientEmail:['',[Validators.required]],     
      numeroCelular: ['', [Validators.required,Validators.pattern('^[0-9]+([,][0-9]+)?$')]]      
    });
  }
  next() {
    if (this.formGroup.invalid) {      
      return;
    }
    this.despacho = this.formGroup.getRawValue();    
    this.commonService.deliveryActivated(this.despacho);    
    this.stepCompleted.emit();
  }
  
  InitFormControl() {
    let clienData=this.authService.getBasicData();
    let idDepartamento= this.searcheDepartamento(clienData.supplyAddress.departmentDescription)
    this.formGroup.controls['departamentoId'].setValue(idDepartamento);
    this.loadProvincias(idDepartamento);
    let idProvincia=this.seacrhProvincia(clienData.supplyAddress.provinceDescription);
    this.formGroup.controls['provinciaId'].setValue(idProvincia);
    this.loadDistritos(idDepartamento,idProvincia);
    let idDistrito=this.searchDistrito(clienData.supplyAddress.districtDescription);
    this.formGroup.controls['distritoId'].setValue(idDistrito);
    this.formGroup.controls['calleDespacho'].setValue(clienData.supplyAddress.summary);
    this.formGroup.controls['referenciaDespacho'].setValue(null);
    this.formGroup.controls['fechaEnvio'].setValue(null);
    this.formGroup.controls['horarioEnvio'].setValue('4');    
    let email=this.authService.getUser().emailAddress;
    this.formGroup.controls['clientEmail'].setValue(email);       
    this.formGroup.controls['numeroCelular'].setValue(clienData.cellPhoneNumber.substring(2));     
    this.assignMinDate();    
    this.fechaMaxRecojo.setDate(this.fechaMaxRecojo.getDate() + 18);
    this.DisableControls();
  
  }

  assignMinDate(): void {
    this.fechaMinRecojo = new Date();
    switch(this.fechaMinRecojo.getDay()){
      case 0:
        this.fechaMinRecojo.setDate(this.fechaMinRecojo.getDate() + 4);
        break;
      case 4:
      case 5:
      case 6:
        this.fechaMinRecojo.setDate(this.fechaMinRecojo.getDate() + 5);
        break;
      default:
        this.fechaMinRecojo.setDate(this.fechaMinRecojo.getDate() + 3);
        break;
    }
  }

  DisableControls(){
    this.formGroup.controls['departamentoId'].disable();   
    this.formGroup.controls['provinciaId'].disable();    
    this.formGroup.controls['distritoId'].disable();
    this.formGroup.controls['calleDespacho'].disable(); 
    this.formGroup.controls['horarioEnvio'].disable();
         
  }
  searchDistrito(descriptionDistrito: string) {
    return this.distritos.filter(x => x.distrito==descriptionDistrito)[0].id;
  }
  searcheDepartamento(descriptionDepartamento:string) {     
       return this.UbigeoList.filter(x => x.departamento==descriptionDepartamento)[0].departamentoId; 
  }
  seacrhProvincia(descriptionProvincia:string) {
    return this.provincias.filter(x => x.provincia==descriptionProvincia)[0].provinciaId;
  }
  loadUbigeo() {
    this._orderService.getAllUbigeo()      
      .subscribe(
        (response) => {         
          if (response.valid) {
            this.UbigeoList = response.data.filter((x: { state: any; }) => x.state);
             this.loadDepartamentos();
             this.InitFormControl(); 
          }
        }
      )
  }
  loadProvincias(idDepartamento: any) {
    this.provincias = Array.from(new Set(this.UbigeoList.filter(x => x.departamentoId == parseInt(idDepartamento)).map(x => x.provinciaId))).
      map(provinciaId => {
        return {
          provinciaId: provinciaId,
          provincia: this.UbigeoList.filter(x => x.departamentoId == parseInt(idDepartamento) && x.provinciaId == provinciaId)[0].provincia
        }
      });
  }
 loadDepartamentos() {
    if (this.UbigeoList.length > 0) {
      this.departamentos = Array.from(new Set(this.UbigeoList.map(x => x.departamentoId))).
        map(departamentoId => {
          return {
            departamentoId: departamentoId,
            departamento: this.UbigeoList.filter(x => x.departamentoId == departamentoId)[0].departamento
          }
        });
    }
  }
  loadDistritos(idDepartamento: any, idProvincia: any) {

    this.distritos = this.UbigeoList.filter(x => x.departamentoId == parseInt(idDepartamento) && x.provinciaId == parseInt(idProvincia));

  }
  
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  weekendsDatesFilter = (d: any): boolean => {
    const day = d.getDay()
    /* Prevent Saturday and Sunday for select. */
    return day !== 0 && day !== 6 ;
  }
}
